/*! PawLab shop-by-category — superseded by v5b (no bestsellers-width align) */
(function () {
  /* Intentionally empty. Layout is owned by pawlab-shop-category-v5b.js */
})();
